export enum EImageAnnotationsColor {
  WHITE = 'white',
  BLACK = 'black',
  YELLOW = 'yellow',
  RED = 'red',
  BLUE = 'blue',
  GREEN = 'green',
}
